'use strict';

export default class OpenMattersReport {
    constructor() {
        if($('.open-matters-list').length > 0) {

            var target = getApiUrl();
            var totalDue = 0;
            var totalExecutionCost = 0;
            //footer text
            var showCourtWarning = false;
            var sections = [
                'Infringement',
                'NoticeOfFinalDemand',
                'EnforcementWarrant',
				'EnforcementHearingOrderStatement',
                'Warrant',
                'ReferredCourtFine',
                'PaymentArrangements'
            ];
            $('#download').parent().css("display","none");
            var form = `<form style="display: hidden" action="/api/sitecore/FineList/GETPdf" method="POST" id="form">
            <input type="hidden" id="htmlString" name="htmlString"/>
          </form>`;
            $('#download').parent().append(form);
            $.ajax({
                method: 'GET',
                url: target
            }).done(function(data) {
                createContent(data);
                $('#download').parent().css("display","block");
                //console.log(data);
                
            }).fail(function(xhr, ajaxOptions, thrownError) {
                var json = {};
                try {
                    json = $.parseJSON(xhr.responseText);
                } catch(err) {
                    //was not passed back valid Json, we will just display a generic error message in this case.
                }

            $('#FinesListError').html(json.Error || "Something went wrong while processing the request.")
        })
            $('#download').on('click', function(e) {
                e.preventDefault();
                $('#download').parent().css("display","none");
                var htmldata = JSON.stringify(htmlEncode($('html').html()));
                $('#htmlString').val(htmldata);
                $("#form").submit();
            });
        }
        //old solution for pdf download
        function sendHtml() {
            $.ajax({
                // url: 'http://dev.fines.com/webapi/GetHtml',
                url: window.location.origin + '/api/sitecore/FineList/GeneratePDF',
                method: 'POST',
                data: {htmlString: JSON.stringify(htmlEncode($('html').html()))}
            }).done(function(data) {
                //console.log('Successfully sent html');
                "True" == data && $("#download").parent().css("display","block");
                // window.location.href = '/api/sitecore/FineList/GETPdf';
            }).fail(function(xhr, ajaxOptions, thrownError) {
                //console.log('Error', thrownError)
            });
        }
        // end of old solution
	function htmlEncode(html) {
            //removed script tags, whitespaces between html elements, lines. replaced whitespaces with _, and style tag with 'stl'
            return html.replace(/<script[^>]*>(?:(?!<\/script>)[^])*<\/script>/g, "").replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/ /g, "_").replace(/style/g, "replacedtopassbarracuda");
    	}

        function mapFinesStage(FinesStage) {
            var map = {
                Infringement: 'Infringements',
                EnforcementWarrant: 'Enforcement warrant',
				EnforcementHearingOrderStatement: 'Enforcement Hearing Order Statement',
                NoticeOfFinalDemand: 'Notices Of Final Demand',
                PaymentArrangements: 'Fines on payment arrangement',
                ReferredCourtFine: 'Referred Court Fine',
                Warrant: 'Warrants',
                PenaltyReminder: 'Penalty Reminder'
            }
            return map[FinesStage] != null ? `${map[FinesStage]}` : FinesStage;
        }

        function getApiUrl() {
            return isLocal() ? '/assets/data/openMatters.json' : $('.open-matters-list').data('open-matters-url')
        }

        function getMethod() {
            return isLocal() ? 'GET' : 'POST';
        }

        function isLocal() {
            return window.location.hostname === 'localhost' ? true : false;
        }

        function get12HourTime(date) {
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ampm;
            return strTime;
        }

        function getDate() {
            var date = new Date();
            return `${get12HourTime(date)}, ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        }
//Co

        function createContent(data) {
            var html = '';
            $.each(sections, function(index, section) {
                var json;
                isLocal() ? json = data[0] : json = data;
                if (section === 'PaymentArrangements') {
                    if (json[section].length === 0) {

                    } else {
                        $.each(json[section], function(index, arrangement) {
                            count (arrangement);
                        });
                    }
                }
                else {
                    count (json[section]);
                }
            });
            $.each(sections, function(index, section) {
                var json;
                isLocal() ? json = data[0] : json = data;
                if (section === 'PaymentArrangements' && Object.keys(json[section]).length > 0 ) {
                    $.each(json[section], function(index, arrangement) {
                    totalExecutionCost += Number(arrangement.ExecutionCost);
                    });
                }
            });

            totalDue = (totalDue + data.DebtorExecutionCost + Number(totalExecutionCost)).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});

            html += getHeader(data);

            $.each(sections, function(index, section) {
                var json;
                isLocal() ? json = data[0] : json = data;

                if (section === 'PaymentArrangements') {
                    if (json[section].length === 0) {

                    } else {
                        $.each(json[section], function(index, arrangement) {
                            html += getSection(arrangement, `Fines on payment arrangement ${index}`).replace(/overdue/g, 'Refer to notice');

                        });
                    }
                } else {
                    json[section].Obligations.length ? html += getSection(json[section], section) : html += '';
                }
            });

            html += getTotal(data);
            html += getFooter();
            $('.open-matters-list').append(html);
        }

        function count(data) {
            $.each(data.Obligations, function(index, obligation){
                if(obligation.AmountDue !== 'undefined'){
                    totalDue += Number(obligation.AmountDue);
                }
            })
        }

        function getHeader(data) {
            return `
				<div style="margin: 10px" class="row justify-content-between">
				    <div class="col-3">
				        <p>Debtor ID: ${data.DebtorID}</p>
                    </div>
					<div class="col-3">
						<p style="text-align: right">as at ${getDate()}</p>
					</div>
				</div>
				<div style="margin: 10px;border-bottom: 5px solid #000000;" class="row justify-content-between">
					<div class="col-5">
						<h4><strong>Fines Victoria Summary Report</strong></h4>
                    </div>
                    <div class="col-3  report-element">
                        <p style="float:right"><strong>Total amount due: $${totalDue}</strong></p>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
			`;
		}

		function getSection(data, FinesStage) {
            if(FinesStage == 'ReferredCourtFine'){
                showCourtWarning = true;
            }
            data.TotalAmount = Number(data.TotalAmount).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
            if (FinesStage.includes('payment arrangement')) {
                return `
                <div style="margin: 10px;" class="row justify-content-right">
                    <h3><strong>${mapFinesStage(FinesStage)} (${data.Obligations.length})</strong></h3>
                </div>
                ${getSubSections(data.Obligations)}` +
                (data.ExecutionCost > 0 ? 
                `<div class="report justify-content-right report-element" style="padding-bottom: 20px">
                    <div class="row justify-content-right"><div class="col-8">Outstanding warrant costs included in this payment arrangement</div>
                        <div class="col-1" style="align-self: center;">
                            <h5><strong>$${data.ExecutionCost}</strong></h5>
                        </div>
                    </div>
                </div>` : '') +`
                <div class="row justify-content-right report-total-amount-due">
                
                    <div class="col-8"><h4><strong>Total amount due for ${mapFinesStage(FinesStage)}</strong></h4></div>
                    <div class="col-1"><h4><strong>$${data.TotalAmount || ''}</strong></h4></div>
                </div>
                `;
            }
            return `
                <div style="margin: 10px;" class="row justify-content-right">
                    <h3><strong>${mapFinesStage(FinesStage)} (${data.Obligations.length})</strong></h3>
                </div>
                ${getSubSections(data.Obligations)}
                <div class="row justify-content-right report-total-amount-due">
                
                    <div class="col-8"><h4><strong>Total amount due for ${mapFinesStage(FinesStage)}</strong></h4></div>
                    <div class="col-1"><h4><strong>$${data.TotalAmount || ''}</strong></h4></div>
                </div>
            `;
        }


        function getSubSections(data) {
            var html = '';

            $.each(data, function(index, obligation) {
                if(obligation.TicketFee == "0.00"){
                    obligation.TicketFee = "N/A"
                }else{
                    obligation.TicketFee = "$" + Number(obligation.TicketFee).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
                }
                if(obligation.WarrantFee == "0.00"){
                    obligation.WarrantFee = "N/A"
                }else{
                    obligation.WarrantFee = "$" + Number(obligation.WarrantFee).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
                }
                if(obligation.OverdueFee == "0.00"){
                    obligation.OverdueFee = "N/A"
                }else{
                    obligation.OverdueFee = "$" + Number(obligation.OverdueFee).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
                }
                if(obligation.CourtsCost == "0.00"){
                    obligation.CourtsCost = "N/A"
                }else{
                    obligation.CourtsCost = "$" + Number(obligation.CourtsCost).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
                }
                if(obligation.AmountDue == "0.00"){
                    obligation.AmountDue = "N/A"
                }else{
                    obligation.AmountDue = "$" + Number(obligation.AmountDue).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
                }
			    if (obligation.OnHold) {
                    obligation.DueDate = "On Hold";
				}
				else if(obligation.AlertMessage !== "" ) {
                    obligation.DueDate = obligation.AlertMessage;
                }
				
				
                if(obligation.ObligationNumber === null){
                    obligation.ObligationNumber = "N/A"
                }
                if(obligation.InfrigementNumber === null){
                    obligation.InfrigementNumber = "N/A"
                }
                if(obligation.RegistrationNumber === null){
                    obligation.RegistrationNumber = "N/A"
                }
                if(obligation.OffenceDate === null){
                    obligation.OffenceDate = "N/A"
                }
                if(obligation.OffenceLocation === null){
                    obligation.OffenceLocation = "N/A"
                }
                if(obligation.OffenceDescription === null){
                    obligation.OffenceDescription = "N/A"
                }
                if(obligation.AddedFee === null){
                    obligation.AddedFee = "N/A"
                }
                if(!obligation.Agency){
                    obligation.Agency = "N/A"
                }
                if(obligation.TicketType == 'CourtFine_2B'){
					html += `               
					<div class = "report report-element">
						<div class = "row justify-content-right">
							<div class="col-2">
								<strong>Obligation number:</strong>
							</div>
							<div class="col-6" >${obligation.ObligationNumber}</div>
							<div class="col-3">
							   
							</div>
							<div class="col-1">
								
							</div>
						</div>
						<div class = "row justify-content-right">
							<div class="col-2">
								<strong>Court Case Number: </strong>
							</div>
							<div class="col-6" >${obligation.InfrigementNumber}</div>
							<div class="col-3">
							   
							</div>
							<div class="col-1">
								
							</div>
						</div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Registration number: </strong>
                            </div>
                            <div class="col-6" >${obligation.RegistrationNumber}</div>
                            
                            <div class="col-3">

                            </div>
                            <div class="col-1">

                            </div>
                        </div>						
						<div class = "row justify-content-right">
							<div class="col-2">
								<strong>Hearing date:</strong>
							</div>
							<div class="col-6" > ${obligation.OffenceDate} ${obligation.OffenceTime12Hour}</div>
							
							<div class="col-3">
							   
							</div>
							<div class="col-1">
								
							</div>
						</div>
						<div class = "row justify-content-right">
							<div class="col-2">
								<strong>Venue:</strong>
							</div>
							<div class="col-6" > ${obligation.OffenceLocation}</div>
							
							<div class="col-3">
							   
							</div>
							<div class="col-1">
								
							</div>
						</div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Type: </strong>
                            </div>
                            <div class="col-6" > ${obligation.OffenceDescription}</div>
                            
                            <div class="col-3">

                            </div>
                            <div class="col-1">

                            </div>
                        </div>
						<div class = "row justify-content-right">
							<div class="col-2">
								<strong>Agency: </strong>
							</div>
							<div class="col-6" > ${obligation.Agency}</div>
							
							<div class="col-3">
								
							</div>
							<div class="col-1">
								
							</div>
						</div>
						
						
					</div>`						
                }else if (obligation.IsCWP){
                    html += `
                    <div class = "report report-element">
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Obligation number:</strong>
                            </div>
                            <div class="col-6" >${obligation.ObligationNumber}</div>
                            <div class="col-3">
                               
                            </div>
                            <div class="col-1">
                                
                            </div>
                        </div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>CWP Reference: </strong>
                            </div>
                            <div class="col-6" >${obligation.InfrigementNumber}</div>
                            <div class="col-3">
                               
                            </div>
                            <div class="col-1">
                                
                            </div>
                        </div>
                        
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Status: </strong>
                            </div>
                            <div class="col-6" >${mapFinesStage(obligation.FinesStage)}</div>
                            
                            <div class="col-3">
                            </div>
                            <div class="col-1">
                            </div>
                        </div>
                        
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>CWP - Failure to Report Date:</strong>
                            </div>
                            <div class="col-6" > ${obligation.OffenceDate} ${obligation.OffenceTime12Hour}</div>
                            
                            <div class="col-3">
                                <strong>Added Fee:</strong>
                            </div>
                            <div class="col-1">
                               $${obligation.AddedFee}
                            </div>
                        </div>                                             
                        
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Type: </strong>
                            </div>
                            <div class="col-6" > ${obligation.OffenceDescription}</div>
                            
                            <div class="col-3">
                                <strong>Amount Due:</strong>
                            </div>
                            <div class="col-1">
                                ${obligation.AmountDue}
                            </div>
                        </div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                
                            </div>
                            <div class="col-6" > </div>
                            
                            <div class="col-3">
                                <strong>Date Due:</strong>
                            </div>
                            <div class="col-1">
                                Overdue
                            </div>
                        </div>
                        
                    </div>`

                }else{
                    
                    html += `
                    <div class = "report report-element">
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Obligation number:</strong>
                            </div>
                            <div class="col-6" >${obligation.ObligationNumber}</div>
                            
                            <div class="col-3">
                                <strong>Infringement amount:</strong>
                            </div>
                            <div class="col-1">
                                ${obligation.TicketFee}
                            </div>
                        </div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Infringement number: </strong>
                            </div>
                            <div class="col-6" >${obligation.InfrigementNumber}</div>
                            
                            <div class="col-3">
                                <strong> PRN fee:</strong>
                            </div>
                            <div class="col-1">
                                ${obligation.OverdueFee}
                            </div>
                        </div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Status: </strong>
                            </div>
                            <div class="col-6" >${mapFinesStage(obligation.FinesStage)}</div>
                            
                            <div class="col-3">
                                <strong> Collection fee:</strong>
                            </div>
                            <div class="col-1">
                                ${obligation.CourtsCost}
                            </div>
                        </div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Registration number: </strong>
                            </div>
                            <div class="col-6" >${obligation.RegistrationNumber}</div>
                            
                            <div class="col-3">
                                <strong>Enforcement warrant fee:</strong>
                            </div>
                            <div class="col-1">
                                ${obligation.WarrantFee}
                            </div>
                        </div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Offence date:</strong>
                            </div>
                            <div class="col-6" > ${obligation.OffenceDate} ${obligation.OffenceTime12Hour}</div>
                            
                            <div class="col-3">
                               
                            </div>
                            <div class="col-1">
                                
                            </div>
                        </div>
                        
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Offence location:</strong>
                            </div>
                            <div class="col-6" > ${obligation.OffenceLocation}</div>
                            
                            <div class="col-3">
                               
                            </div>
                            <div class="col-1">
                                
                            </div>
                        </div>
                        
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Offence description: </strong>
                            </div>
                            <div class="col-6" > ${obligation.OffenceDescription}</div>
                            
                            <div class="col-3">
                                <strong>Total due:</strong>
                            </div>
                            <div class="col-1">
                                ${obligation.AmountDue}
                            </div>
                        </div>
                        <div class = "row justify-content-right">
                            <div class="col-2">
                                <strong>Agency: </strong>
                            </div>
                            <div class="col-6" > ${obligation.Agency}</div>
                            
                            <div class="col-3">
                                <strong>  Date due: </strong>
                            </div>
                            <div class="col-1">
                                ${obligation.DueDate} 
                            </div>
                        </div>
                    </div>
				`
                }
            });
            return html;
        }

        function getTotal(data) {
            return (data.DebtorExecutionCost > 0 ? `
            <div class="report justify-content-right report-element">
                <div class="row justify-content-right">
                    <div class="col-8">You have outstanding warrant costs that are not on a payment agreement. We are unable to process the listed warrant cost payments online. Please contact our offices on 1800 111 222 between 9am-5pm Monday to Friday to discuss your payment options.</div>
                        <div class="col-1" style="padding-top: 0.5em;align-self: center;">
                            <h5><strong>$${data.DebtorExecutionCost}</strong></h5>
                        </div>
                </div>
            </div> ` : '') + `
                        <div class="row justify-content-right total-amount-due" style="margin-top: 0; font-size: 1.6em">
                        
                            <div class = "col-8">
                                <h3><strong>Total amount due</strong></h3>
                            </div>
                            <div class = "col-1">
                                <h3>$${totalDue}</h3>
                            </div>
                        </div>
                    </div>
                </div>`;
        }

        function getFooter() {
          var footer=``;
          if(showCourtWarning==true){
            footer=`<div class="row">
    					<div class="col-12"><small><sup>&starf;</sup>Court fines on a payment arrangement will be listed in respective payment arrangement section.</small></div>
    				</div>`;
          }
            return footer+`
				<div style="margin-bottom: 30px" class="row">
					<div class="col-12">
						<small>The summary provided may not be a complete listing of your matters. Infringement information may
						vary as a result of, but not limited to: a difference in the spelling of your name, a difference in your address
						or a difference in your licence number. For further information, please contact Fines Victoria on 9200 8111
						or 1300 369 819 (regional callers) between the hours of 8am and 6pm Monday to Friday (excluding public holidays).
						This summary does not include fines that have not been registered with Fines Victoria.
				    	</small>
				    </div>
				</div>
			`;
        }
    }
}
